import mediaQueries from "./media-queries";
import icons from "../imgs/icons";

const wrapper = (area) => {
  let border, background;

  if (!/Landing/.test(area)) {
    border = '1px solid #EDEDED';
    background = "#ffffff";
  } else {
    border = 'none';
    background = "linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0))";
  }

  return {
    position: "fixed",
    flex: "none",
    background: `${background}`,
    borderBottom: `${border}`,
    top: 0,
    width: "100%",
    zIndex: "100",
    [mediaQueries.tablet]: {
      position: "absolute"
    }
  };
};

const container = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "50px",
  padding: "0 30px",
  [mediaQueries.tablet]: {
    padding: "0 2rem",
    height: "70px"
  },
};

const back = {
  background: `url(${icons.backIcon}) no-repeat`,
  border: "none",
  width: "35px",
  height: "19px",
  padding: 0,
  margin: 0,
  display: "block",
  backgroundSize: "100%",
  ":focus": {
    outline: "none"
  },
  cursor: "pointer",
  [mediaQueries.tablet]: {
    width: "22px",
    height: "22px"
  },
  position: "relative"
};

const close = () => {
  return {
    height: "18px",
    width: "18px",
    position: "relative",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundColor: "transparent",
    backgroundImage: `url(${icons.closeIcon})`,
    backgroundSize: "100%",
    border: "none",
    cursor: "pointer",
    ":focus": {
      outline: "none"
    },
    display: "block",
    [mediaQueries.tablet]: {
      height: "24px",
      width: "24px",
    },
  };
};

const undo = {
  ...close(),
  backgroundImage:  `url(${icons.restartIcon})`
};

const play = {
  border: "none",
  cursor: "pointer",
  background: "transparent",
  fontFamily: "JWSansBook",
  fontSize: "12px",
  color: "#000",
  letterSpacing: "0.45px",
  lineHeight: "35px",
  paddingLeft: "45px",
  position: "relative",
  ":before": {
    content: "''",
    background: `transparent url(${icons.playIcon}) no-repeat`,
    width: "35px",
    height: "35px",
    backgroundSize: "100%",
    position: "absolute",
    top: "0",
    left: "0"
  },
  ":focus": {
    outline: "none"
  }
};

const logo = (area) => {
  let styles = {
    position: "relative",
    cursor: "pointer",
    width: "166px",
    " img": {
      maxWidth: "100%"
    }
  };

  if (/Landing/.test(area)) {
    styles.display = "none";
  }

  return styles;
};

export default { wrapper, container, back, close, play, logo, undo };



// WEBPACK FOOTER //
// ./src/styles/header.js